import { Component, Input, Output, EventEmitter } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
export const TAB_KEY = 9;

@Component({
  selector: 'app-dot-indicator',
  template: `
    <a href="javascript:void(0)" *ngFor="let item of items;let i = index;" class="dot"
       [title]="item.active?'currently active' : ''"
       [attr.aria-current]="item.active?'page' : ''"
			 [style.background]="dotColor" [attr.aria-label]="item.title"
       [class.active]="item.active"  (keypress)="OnClick(i, $event)"
       (click)="OnClick(i, $event)">
       <span class="dot-number">{{i+1}} {{item.title}}</span></a>
	`,
  styleUrls: ['./pageslider.component.scss']
})
export class DotIndicatorComponent {

  // PUBLIC PROPERTIES
  private _page = 0;
  private _pageCount = 0;
  @Output() pageChange = new EventEmitter<number>();
  @Input() labels;
  @Input() set page(p: number) {
    this._page = p;
    this.updateSelected();
  }

  @Input() set pageCount(p: number) {
    this._pageCount = p || 0;
    this.updateItems();
  }

  @Input() dotColor = 'white';


  // DATA REPRESENTATION

  // An array of page dots, one of which (the active one) is true.
  public items: { active: boolean, title: string }[] = [];
  private updateItems() {
    this.items = new Array(this._pageCount);
    for (let i = 0; i < this._pageCount; i++) {
      this.items[i] = {
        active: i === this._page,
        title: this.labels[i].title.replace(/<\/?[^>]+(>|$)/g, "")
      };
    }
  }

  private fetchLabel(i) {
    if (i === '0') {
      return 'AT&T Business Console.';
    } else if (i === '1') {
      return 'AT&T Business Console device management program.';
    } else if (i === '2') {
      return 'Application Marketplace for Business.';
    }
  }

  private updateSelected() {
    if (this.items.length !== this._pageCount) {
      return this.updateItems();
    }
    if (this.items.length === 0) {
      return;
      }
    for (let i = 0; i < this._pageCount; i++) {
      this.items[i].active = false;
    this.items[this._page].active = true;
    }
  }

  public OnClick(index, event) {
    console.log('inside onclick dot indicator');
    const keyValue = event.charCode || event.keyCode;

    if (event.keyCode !== TAB_KEY && keyValue !== 32) {
      this.pageChange.emit(index);
    }
  }

}
